import { Component, OnInit } from '@angular/core';
import { IUser } from 'src/app/shared/models';
import { StorageService, UtilService, VariablesService } from 'src/app/shared/services';

@Component({
  selector: 'app-welcome-back-nudge',
  templateUrl: './welcome-back-nudge.component.html',
  styleUrls: ['./welcome-back-nudge.component.scss']
})
export class WelcomeBackNudgeComponent implements OnInit {

  userdata: IUser;
  visible = true;

  constructor(
    public util: UtilService,
    public vars: VariablesService,
    public storage: StorageService
  ) {}

  ngOnInit(): void {
    this.vars.userData.subscribe(res => {
      this.userdata = res;
    });
    this.storage.addSessionData('welcome-nudge', true);
    setTimeout(() => {
      this.visible = false;
    }, 12000);
  }

}
